import { Garden, Border, Zone } from "@/types";

export const garden: Garden = {
  zones: {
    "noord-oost": {
      alias: "Entree",
      borders: {
        A: {
          alias: "rechtsvoor",
          plants: [167, 166, 165, 0, 207], //TODO Hortensia
        },
        B: {
          alias: "midden",
          plants: [24, 52, 10, 53, 55, 54, 56, 57],
        },
        C: {
          alias: "cirkel",
          plants: [5, 58, 208],
        },
        D: {
          alias: "linksvoor",
          plants: [51, 50, 45, 47, 59, 48, 49],
        },
        E: {
          alias: "linksachter",
          plants: [66],
        },
        F: {
          alias: "rechtsachter",
          plants: [65, 30, 55, 59, 60, 61, 63, 64, 81],
        },
      },
    },
    "noord-boven": {
      alias: "Voortuin",
      borders: {
        A: {
          alias: "linksvoor",
          plants: [68, 69, 67, 70, 71, 72],
        },
        B: {
          alias: "raam voor",
          plants: [79, 172, 78, 72, 77, 82],
        },
        C: {
          alias: "raam achter",
          plants: [63, 72, 84, 83],
        },
        D: {
          alias: "rechts (gazon)",
          plants: [24, 11, 73, 29, 74, 75, 76, 53, 0], //TODO: Sierappel
        },
      },
    },
    "noord-beneden": {
      alias: "Beneden border",
      borders: {
        A: { alias: "cirkels", plants: [163] },
        B: { alias: "hoekje (links)", plants: [] },
        C: {
          alias: "links",
          plants: [148, 138, 122, 149, 103, 150, 151, 152, 153, 154, 65, 155],
        },
        D: {
          alias: "midden",
          plants: [155, 156, 26, 157, 158, 132, 159, 74, 125, 138, 74],
        },
        E: {
          alias: "rechts",
          plants: [125, 160, 161, 162, 22, 164, 165, 22, 0], //TODO: Hortensia
        },
      },
    },
    "noord-west": {
      alias: "Westkant",
      borders: {
        A: {
          alias: "rechtsvoor",
          plants: [131, 30, 0], //TODO:Gras
        },
        B: {
          alias: "schuurrechts",
          plants: [132, 133, 134, 35, 137, 136, 0, 206], //TODO:VInca, Esdoorn
        },
        C: {
          alias: "buitenkant",
          plants: [138, 139, 42, 206, 23, 141, 142, 144, 143, 65, 67, 146, 170], //TODO Esdoorn
        },
      },
    },
    vijver: {
      alias: "Vijver",
      borders: {
        A: {
          alias: "hoge kant",
          plants: [130, 14, 109, 128, 124, 129, 125, 65, 10, 60, 112, 127, 126],
        },
        B: { alias: "moeras", plants: [] },
        C: { alias: "water", plants: [] },
        D: {
          alias: "lage kant",
          plants: [
            119,
            40,
            117,
            120,
            19,
            113,
            112,
            121,
            123,
            98,
            105,
            118,
            111,
            124,
            122,
          ],
        },
      },
    },
    west: {
      alias: "Achtertuin",
      borders: {
        A: {
          alias: "bad",
          plants: [],
        },
        B: {
          alias: "hoek hoge vijver",
          plants: [19, 110, 108, 21, 109, 36, 30, 90],
        },
        C: {
          alias: "hoek kantoor",
          plants: [95, 102, 103, 105, 30, 26, 80, 106],
        },
        D: {
          alias: "raam woonhuis",
          plants: [85, 86, 87, 88, 63],
        },
        E: {
          alias: "midden",
          plants: [168, 65, 62, 169],
        },
        F: {
          alias: "hoek overkapping links",
          plants: [90, 89, 2, 92, 0, 91], //TODO Roos
        },
        G: {
          alias: "hoek overkapping rechts",
          plants: [92, 41, 93, 94, 0, -1], //TODO Jasmijn, gras
        },
        H: {
          alias: "uitgang links",
          plants: [85, 95, 50, 0], //TODO Roos
        },
        I: {
          alias: "uitgang rechts",
          plants: [24, 96, 97],
        },
        J: {
          alias: "raam kantoor",
          plants: [11, 99, 100, 101, 98],
        },
      },
    },
    //  "uiterst-zuid-west":{
    //    "alias": "Kippenwei",
    //    borders: {}
    //  },
    //  "uiterst-zuid-oost":{
    //   "alias": "Moestuin",
    //   borders: {}
    //  },
    "zuid-oost": {
      alias: "Mediterrane hoek",
      borders: {
        A: {
          alias: "Klimmerhoekje",
          plants: [1, 2, 3],
        },
        B: {
          alias: "Vijgenborder",
          plants: [5, 4, 8, 7, 6],
        },
        C: {
          alias: "Rozenhoek",
          plants: [62, 12, 13, 15, 14, 209],
        },
        D: {
          alias: "Waterpartijtje",
          plants: [10, 9, 1, 11],
        },
      },
    },
    oost: {
      alias: "Oostkant",
      borders: {
        A: {
          alias: "raam 1",
          plants: [16, 13, 17],
        },
        B: {
          alias: "raam 2",
          plants: [18, 19, 0], //TODO Hosta
        },
        C: {
          alias: "raam 3",
          plants: [18, 20],
        },
        D: {
          alias: "raam 4",
          plants: [21, 22],
        },
        E: {
          alias: "buitenkant-achter",
          plants: [23, 24, 25, 28, 12, 27, 30, 29, 31],
        },
        F: {
          alias: "buitenkant-midden",
          plants: [32, 33, 0, 207, 34, 35], //TODO Hotlips
        },
        G: {
          alias: "buitenkant-voor",
          plants: [30, 44, 42, 43, 40, 39, 38, 37],
        },
      },
    },
  },
};
